import React, { useEffect, useState } from 'react';
import { CTAButton } from './CTAButton';
export const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 1000) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 shadow-lg z-50" data-id="element-90">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between" data-id="element-91">
        <div className="mb-3 sm:mb-0" data-id="element-92">
          <p className="font-serif font-bold text-gray-800" data-id="element-93">
            Przerwij Błędne Koło Odrzucenia
          </p>
          <p className="text-red-500 font-bold" data-id="element-94">
            Specjalna cena: 29,99 zł (zamiast 149,99 zł)
          </p>
        </div>
        <CTAButton text="Pobieram e-book" data-id="element-95" />
      </div>
    </div>;
};